import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Textarea,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GRAY_LIGHT, VARIANT, WHITE } from "../../../../constants/colors";
import { useRecoilState, useSetRecoilState } from "recoil";
import { toast } from "react-toastify";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import SystemApi from "../../../../services/systemApi";
import { servicoStatusInterface } from "..";
import { dateForAPI } from "../../../../constants/dataFormat";
import moment from "moment";
import { LoggedUser } from "../../../../atoms/userLogged";
import SuportSolicitationsAPI from "../../../../services/servicosSolicitacoesApi";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { validateFields } from "../../../../defaultFunctions/validators";

const ModalTrocaStatus = ({ isOpen, setIsOpen, item }: any) => {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const user = useRecoilState(LoggedUser)[0];

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const idUser = Number(jwtToken.idCliente);

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const [listaServicoStatus, setlistaServicoStatus] = useState(
    Array<servicoStatusInterface>
  );
  const [statusId, setstatusId] = useState(0);
  const [descricao, setDescricao] = useState("");
  const refresh = useRecoilState(refreshGlobal)[0];

  const onClose = () => {
    setIsOpen(false);
  };

  // async function getServicoStatus() {
  //   try {
  //     const response = await SystemApi.getServicoStatus();
  //     setlistaServicoStatus(response);
  //   } catch (error) {
  //     console.log("error: ", error);
  //   }
  // }
  // useEffect(() => {
  //   getServicoStatus();
  // }, [item]);

  function onsubmit() {
    const objeto = {
      data: moment().format(dateForAPI),
      idResponsavel: idUser,
      idServicoSolicitacoes: item.id,
      idServicoStatus: item.idServicoStatus,
      descricao: descricao,
    };
    // console.log("objeto", objeto);
    if(validateFields(objeto)){
      postSuporteStatus(objeto);
    }
    
  }

  async function postSuporteStatus(obj: any) {
    try {
      const response = await SuportSolicitationsAPI.postSuporteAndamento(
        item.id,
        obj
      );
      toast.success("Status da solicitação alterado com sucesso!");
      setRefreshGlobal(refresh + 1);
      onClose();
    } catch (error) {
      toast.error("Não foi possível alterar o status da solicitação!");
      console.log("error:", error);
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"3xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>Adicionar Observação</ModalHeader>
          <ModalBody minH={"30vh"}>
            {/* <FormControl my={2}>
              <FormLabel>Novo Status</FormLabel>
              <Select
                placeholder={"Status de Serviço"}
                ml={4}
                value={statusId.toString()}
                w={"80%"}
                onChange={(e: any) => {
                  setstatusId(Number(e.target.value));
                }}
              >
                {listaServicoStatus &&
                  listaServicoStatus.map(
                    (item: servicoStatusInterface, index: number) => {
                      return (
                        <option key={index} value={item.id}>
                          {item.situacao}
                        </option>
                      );
                    }
                  )}
              </Select>
            </FormControl> */}
            <FormControl my={4}>
              <FormLabel>Observação</FormLabel>
              <Textarea
                w={"90%"}
                onChange={(e: any) => {
                  setDescricao(e.target.value);
                }}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              background={GRAY_LIGHT}
              mr={3}
              onClick={() => {
                onClose();
              }}
            >
              Cancelar
            </Button>
            <Button
              background={VARIANT}
              color={WHITE}
              onClick={() => {
                onsubmit();
              }}
            >
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalTrocaStatus;
